import { CommonUtilities } from '../../../commonUtils';

export default class trackServices {

    static async TrackListing(data: any) {
        var url = 'catalogue/projectAsset/listMyAsset?' + data;
        return CommonUtilities.getData(url);
    }

    static async AssociatedTracks(data: any) {
        var url = "contracts/compilation/associatedTracks/" + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;
        return CommonUtilities.getData(url);
    }

    static async AssociatedTrackExport(data: any) {
        var url = "contracts/compilation/associatedTracks/" + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;      
        
        return CommonUtilities.exportWithToken('GET', url, {}, data.exportType, data.type);
    }


    static async listMyassetContractsTrack(data: any) {
        console.log(data);
        var url = "catalogue/projectAsset/listMyassetContracts?assetType=" + data.assetType +
            "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize + "&isrc=" + data.isrc;
        return CommonUtilities.getData(url);
    }


    static trackSave(data: any) {
        var url = 'contracts/mechanical/tracks';
        return CommonUtilities.postData(url, data);
    }

    static uploadSound(file: any, isrc: any, trackName: any) {
        var url = 'contracts/mechanical/tracks/uploadSound';
        var data = { 'isrc': isrc, 'trackName': trackName };
        return CommonUtilities.postUploadFile(url, file, data);
    };


    static generateItem(data: any) {
        var url = 'contracts/mechanical/tracks/generateItem';
        return CommonUtilities.postData(url, data);
    }


}